import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import BackButtonIcon from "../../assets/icons/BackButtonIcon";

export default function BackButton() {
  const navigate = useNavigate();

  return (
    <Button onClick={() => navigate(-1)} className="button-bordered-light h-10">
      
        <BackButtonIcon />
      Back
    </Button>
  );
}
